// extracted by mini-css-extract-plugin
module.exports = {"container":"_14JQQI5g9V8SkhX8lyjNN7","groupsList":"_15qcH4L9xVLvhtYaH4N1j1"};